import {
  BOOKINGS_NAMESPACE,
  FETCH_CURRENT_BOOKING_CANDIDATES
} from "@/store/modules/bookings/actions";

export const bookingApplicationUpdater = async ({ dispatch, handler }) => {
  const response = await handler();
  dispatch(
    `${BOOKINGS_NAMESPACE}/${FETCH_CURRENT_BOOKING_CANDIDATES}`,
    {},
    {
      root: true
    }
  );
  return response;
};
